<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="paras">‘For the wages of sin is death’</p>
<p class="paras"><em>—Romans 6: 23</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?af6bde70